export const enDash = "–";

/** Supported words for pluralization */
type PluralKeys =
  | "composer"
  | "collaborator"
  | "feedback"
  | "other"
  | "review"
  | "season"
  | "submission"
  | "tier";

const pluralizationMap: Record<PluralKeys, { empty?: string; singular: string; plural: string }> = {
  composer: { singular: "composer", plural: "composers" },
  collaborator: { singular: "collaborator", plural: "collaborators" },
  feedback: { singular: "feedback", plural: "feedbacks" },
  other: { singular: "other", plural: "others" },
  review: { singular: "review", plural: "reviews" },
  season: { singular: "season", plural: "seasons" },
  submission: { singular: "submission", plural: "submissions" },
  tier: { singular: "tier", plural: "tiers" },
};

/** Pluralize a (supported) word */
export const pluralize = (word: PluralKeys, count: number, capitalize = false): string => {
  const pluralConfig = pluralizationMap[word];
  let result = "";
  if (count === 1) {
    result = pluralConfig.singular;
  } else if (count === 0) {
    result = pluralConfig.empty ?? pluralConfig.plural;
  } else {
    result = pluralConfig.plural;
  }

  if (capitalize) {
    const parts = result.split(" ");
    for (let i = 0; i < parts.length; i++) {
      parts[i] = parts[i][0].toUpperCase() + parts[i].substring(1);
    }
    result = parts.join(" ");
  }
  return result;
};

/** Truncate a string to a specified length */
export const truncate = (input: string, length: number) => {
  return input.length <= length ? input : `${input.substring(0, length)}...`;
};
